import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getSections} from 'src/openapi/admin/apis/ConferenceSectionsApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    conferenceId: number,
};

export const useGetSections = ({conferenceId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => apiDispatch(
        getSections({conferenceId}, {signal}),
    ), [conferenceId, apiDispatch]);

    return useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
    });
};
